__turbopack_context__.v({
  "className": "_0bjUvq_className",
  "variable": "_0bjUvq_variable",
});
